<div class="container-fluid h-100">
    <div class="m-auto login-panel p-4 col-12 col-xl-4 col-md-6 mt-3">

        <div class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Email" [(ngModel)]="User.Email" (keyup.enter)="tryCredentials()" required>
            </mat-form-field>
        </div>
        @if (!ShowResetForm) {
        <div class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Password" [(ngModel)]="User.Password" (keyup.enter)="tryCredentials()" required
                    [type]="IsPasswordVisible ? 'text' : 'password'">
                <mat-icon class="material-symbols-outlined" matSuffix (click)="$event.stopPropagation(); IsPasswordVisible = !IsPasswordVisible">
                    {{IsPasswordVisible ? 'visibility_off' : 'visibility'}}
                </mat-icon>
            </mat-form-field>
        </div>
        }
        <div class="row mt-3">
            @if (!ShowResetForm) {
            <button class="col mx-2" style="white-space: pre-line;" mat-raised-button color="primary" (click)="User.Email = ''; ShowResetForm = true">
                Mot de passe oublié ?
            </button>
            }
            @if (ShowResetForm) {
            <button class="col mx-2" mat-raised-button color="primary" (click)="User.Email = ''; ShowResetForm = false">
                Retour
            </button>
            }
            @if (!ShowResetForm) {
            <button class="col mx-2" mat-raised-button color="primary" (click)="tryCredentials()" [disabled]="!User.Email || !User.Password">
                Se connecter
            </button>
            }
            @if (ShowResetForm) {
            <button class="col mx-2" mat-raised-button color="primary" (click)="resetPassword()" [disabled]="!User.Email">
                Envoyer
            </button>
            }
        </div>
        <!-- @if (!ShowResetForm) {
        <div class="row mt-3">
            <button class="col mx-2" mat-raised-button color="accent" (click)="askForAccess()" >
                Demander mes accès
            </button>
        </div>
        } -->
    </div>
</div>